/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v27.3.0 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
import { b as e } from "../../common/enums.js";
var d;
!function (e) {
  e.background = "background", e.backgroundBatch = "backgroundBatch", e.selected = "selected", e.normal = "normal", e.filtered = "filtered";
}(d || (d = {}));
var i = {
  getIsFocus: function getIsFocus(_ref) {
    var e = _ref.focusedFieldGuids,
        d = _ref.fieldGuid;
    return "has" in e && e.has(d) || "indexOf" in e && e.indexOf(d) > -1 ? 1 : 0;
  },
  getStatus: function getStatus(_ref2) {
    var i = _ref2.activeToolset,
        n = _ref2.fieldsBackgroundOnly,
        a = _ref2.fieldsBackgroundOnlyBatch,
        s = _ref2.fieldGuid,
        c = _ref2.selectedFieldGuids,
        l = _ref2.filteredFieldGuids;
    return a ? d.backgroundBatch : n ? d.background : [e.DRAW_EDIT, e.DRAW_EDIT_IMPORT].includes(i) ? d.normal : "has" in c && c.has(s) || "indexOf" in c && c.indexOf(s) > -1 ? d.selected : "has" in l && !l.has(s) ? d.filtered : d.normal;
  }
};
export { i as FieldUtils, d as STATUS };